import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import ROUTES from 'constants/routes';
import { getSessionAuthorized } from 'app/session/selectors';
import { BaseContainerWrap } from './styles';
import Router from './router';
import { exitContainer } from './actions';

const BaseContainer = ({ authenticated, redirectToDashboard, onExit }) => {
  useEffect(() => {
    if (authenticated) {
      redirectToDashboard();
    }
    return () => {
      onExit();
    };
  }, [authenticated, redirectToDashboard, onExit]);

  return (
    <BaseContainerWrap>
      <Router />
    </BaseContainerWrap>
  );
};

BaseContainer.propTypes = {
  authenticated: PropTypes.number.isRequired,
  redirectToDashboard: PropTypes.func.isRequired,
  onExit: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  authenticated: getSessionAuthorized(state),
});

const mapDispatchToProps = {
  redirectToDashboard: () => push(ROUTES.DASHBOARD),
  onExit: exitContainer,
};

export default connect(mapStateToProps, mapDispatchToProps)(BaseContainer);
